// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d54a8373","455":"8cc06501","977":"1eb98c29"}[chunkId] + ".chunk.js";
};